<div id="tour-date-selector" class="pro-options__range">
  <div id="slider"></div>
</div>
<div class="pro-options__print-range">
  As of: {{ date | date: 'shortDate' }}
</div>
